import { Alert, Button, Card, Col, Row, Skeleton, Tag, Tooltip } from 'antd';
import message from '../../../utils/messageWithScroll';
import { ButtonFilter } from 'components/ButtonFilter';
import NumberItem from 'components/NumberItem';
import { LanguageContext } from 'contexts/LanguageContext';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import { Number } from 'interfaces/number';
import React, { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import AddEditNumberView from './AddEditNumberView';
import { System } from 'interfaces/system';
import { SystemConsumer } from 'contexts/legacy/SystemContext';

interface NumberViewProps {
	number: Number;
	system: System;
	setActiveTabKey: string;
	setActiveTabTutorialKey: string;
	// setActiveTabKey: React.Dispatch<React.SetStateAction<string>>;
	// setActiveTabTutorialKey: React.Dispatch<React.SetStateAction<string>>;
}

function NumberView({ number, system, setActiveTabKey, setActiveTabTutorialKey }: NumberViewProps) {
	const { dictionary } = useContext(LanguageContext);
	const [isVisible, setIsVisible] = useState(false);
	const [isActiveNumber, setIsActiveNumber] = useState(true);

	function handleShowActiveNumbers() {
		setIsActiveNumber(true);
	}

	function handleShowInactiveNumbers() {
		setIsActiveNumber(false);
	}

	function handleAddShow() {
		if (number.creationBasicLimit) {
			setIsVisible(true);
		} else {
			message.warning(dictionary.plan_limit);
		}
	}

	function handleCancel() {
		setIsVisible(false);
	}

	function handleOk() {
		setIsVisible(false);
	}

	return (
		<>
			{isVisible && (
				<AddEditNumberView
					visible={isVisible}
					title={<FormattedMessage id="add_basic_numbers_title" />}
					cancelAction={handleCancel}
					okAction={handleOk}
					setActiveTabKey={setActiveTabKey}
					setActiveTabTutorialKey={setActiveTabTutorialKey}
				/>
			)}{' '}
			<Card
				title={<FormattedMessage id="basic_numbers_title" />}
				style={{ width: 'auto', margin: 5 }}
				extra={
					<FormattedMessage
						id="amount_of_numbers_basic"
						values={{
							active_basic: number.active_numbers_basic,
							total_basic: number.max_numbers_basic,
						}}
					/>
				}
			>
				<Row justify="space-between">
					<Col span={12}>
						<Skeleton loading={number.loadingNumber}>
							<ButtonFilter
								name={dictionary.actives}
								active={isActiveNumber}
								count={number.basicNumbers.actives.length ? number.basicNumbers.actives.length : 0}
								onClick={handleShowActiveNumbers}
							/>
							<ButtonFilter
								name={dictionary.inactives}
								active={!isActiveNumber}
								count={
									number.basicNumbers.inactives.length ? number.basicNumbers.inactives.length : 0
								}
								onClick={handleShowInactiveNumbers}
							/>
						</Skeleton>
					</Col>
					<Col span={12}>
						<Row type="flex" justify="end">
							<Col span={'auto'}>
								<Button
									onClick={handleAddShow}
									className="ml-2"
									style={{
										borderTop: 0,
										borderLeft: 0,
										borderRight: 0,
										borderRadius: 0,
										borderWidth: 3,
										float: 'right',
									}}
								>
									<FormattedMessage id="add_new_number" />
								</Button>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row style={{ marginTop: 10 }}>
					<Skeleton loading={number.loadingNumber}>
						{isActiveNumber ? (
							<>
								{' '}
								{number.basicNumbers.actives.length > 0 ? (
									<>
										<div
											style={{
												backgroundColor: '#e8f9fe',
												padding: 12,
												borderBottom: '1px solid #fff',
											}}
										>
											<Row>
												<Col span={9} style={{ lineHeight: '25px', fontWeight: 'bold' }}>
													<FormattedMessage id="numbers_form_nickname" />
												</Col>
												<Col span={5} style={{ lineHeight: '25px', fontWeight: 'bold' }}>
													<FormattedMessage id="number" />
												</Col>
												<Col span={4} style={{ lineHeight: '25px', fontWeight: 'bold' }}>
													<FormattedMessage id="api" />
												</Col>
												<Col
													span={4}
													style={{ lineHeight: '25px', fontWeight: 'bold', textAlign: 'center' }}
												>
													<div
														style={{
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'center',
														}}
													>
														<Tooltip title={<FormattedMessage id="audio_transcription_tooltip" />}>
															<span style={{ cursor: 'help' }}>
																<FormattedMessage id="audio_transcription_column" />
																<sup
																	style={{
																		fontSize: '8px',
																		color: '#1890ff',
																		fontWeight: 'bold',
																		marginLeft: '-2px',
																		verticalAlign: 'super',
																		position: 'relative',
																		top: '-2px',
																	}}
																>
																	<FormattedMessage id="new" />
																</sup>
															</span>
														</Tooltip>
													</div>
												</Col>
												<Col
													span={2}
													style={{
														lineHeight: '25px',
														fontWeight: 'bold',
														textAlign: 'right',
													}}
												>
													<FormattedMessage id="actions" />
												</Col>
											</Row>
										</div>
										{number &&
											number.basicNumbers.actives.map((number) => (
												<NumberItem
													key={number.api + number.id}
													numberInfo={number}
													numberType={'basic'}
												/>
											))}
									</>
								) : (
									<Alert
										message={<FormattedMessage id="not_found_registers" />}
										type="warning"
										showIcon
									/>
								)}
							</>
						) : (
							<>
								{number.basicNumbers.inactives.length > 0 ? (
									<>
										<div
											style={{
												backgroundColor: '#e8f9fe',
												padding: 12,
												borderBottom: '1px solid #fff',
											}}
										>
											<Row>
												<Col span={9} style={{ lineHeight: '25px', fontWeight: 'bold' }}>
													<FormattedMessage id="numbers_form_nickname" />
												</Col>
												<Col span={5} style={{ lineHeight: '25px', fontWeight: 'bold' }}>
													<FormattedMessage id="number" />
												</Col>
												<Col span={4} style={{ lineHeight: '25px', fontWeight: 'bold' }}>
													<FormattedMessage id="api" />
												</Col>
												<Col
													span={4}
													style={{ lineHeight: '25px', fontWeight: 'bold', textAlign: 'center' }}
												>
													<div
														style={{
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'center',
														}}
													>
														<Tooltip title={<FormattedMessage id="audio_transcription_tooltip" />}>
															<span style={{ cursor: 'help' }}>
																<FormattedMessage id="audio_transcription_column" />
																<sup
																	style={{
																		fontSize: '8px',
																		color: '#1890ff',
																		fontWeight: 'bold',
																		marginLeft: '-2px',
																		verticalAlign: 'super',
																		position: 'relative',
																		top: '-2px',
																	}}
																>
																	<FormattedMessage id="new" />
																</sup>
															</span>
														</Tooltip>
													</div>
												</Col>
												<Col
													span={2}
													style={{
														lineHeight: '25px',
														fontWeight: 'bold',
														textAlign: 'right',
													}}
												>
													<FormattedMessage id="actions" />
												</Col>
											</Row>
										</div>
										{number.basicNumbers.inactives.map((number) => (
											<NumberItem
												key={number.api + number.id}
												numberInfo={number}
												numberType={'basic'}
											/>
										))}
									</>
								) : (
									<Alert
										message={<FormattedMessage id="not_found_registers" />}
										type="warning"
										showIcon
									/>
								)}
							</>
						)}
					</Skeleton>
				</Row>
			</Card>
		</>
	);
}

export default SystemConsumer(NumberConsumer(NumberView));
